<template>
    <v-input v-model="modelValue" :rules="rules">
        <v-rating v-model="modelValue" :length="maxLength" class="ma-2" density="default" clearable>
            <template v-slot:item="props">
                <v-btn @click="props.onClick" variant="plain" :ripple="false" icon>

                    <v-icon>
                        {{ props.isFilled ? `mdi-numeric-${props?.index + 1}-box` : `mdi-numeric-${props?.index + 1}` }}
                    </v-icon>
                </v-btn>
            </template>
        </v-rating>
    </v-input>
</template>

<script setup>
import { defineModel, defineProps } from "vue"
const modelValue = defineModel({
    required: true,
    type: Number
})
const props = defineProps({
    required: {
        type: Boolean,
        default: () => {
            return false
        },
        required: false
    },
    maxLength: {
        type: Number,
        default: () => {
            return 5
        },
        required: true
    }
})
const rules = [
    (v) => {
        return !props.required || !!v || "Silahkan isi bagian ini"
    }
]
</script>

<style lang="scss" scoped></style>